
WB.WidgetGrids = WB.WidgetGrids || {};

WB.WidgetGrids.WidgetDirectiveLink = function() {
    return function (scope, element, attr) {
        scope.isBreakpointSmall = scope.$root.isBreakpointSmall;
    };
};

WB.WidgetGrids.WidgetDirective = function() {
    return {
        scope: {
            widget: '='
        },
        restrict: 'AE',
        link: WB.WidgetGrids.WidgetDirectiveLink(),
        template: `<div ng-if="widget.Type == 'Ad'">
        <div>
            <display-ad-widget
                slotId="widget.PositionId"
                width="{{ widget.Width }}"
                height="{{ widget.Height }}"
                showOnPhone="widget.ShowOnPhone"
                showOnTablet="widget.ShowOnTablet"
                showOnDesktop="widget.ShowOnDesktop" />
        </div>
    </div>
    <div ng-if="widget.Type == 'Camera'">
        <traffic-cams-widget />
    </div>
    <div ng-if="widget.Type == 'CurrentConditions'">
        <current-conditions-widget scope="scope" />
    </div>
    <div ng-if="widget.Type == 'DailyForecastSummary'">
        <daily-forecast-summary-widget />
    </div>
    <div ng-if="widget.Type == 'Map'">
        <map-widget />
    </div>
    <div ng-if="widget.Type == 'Pollen'">
        <pollen-widget />
    </div>
    <div ng-if="widget.Type == 'StorySection'">
        <story-section-widget> </story-section-widget>
    </div>
    <div ng-if="widget.Type == 'WeatherCamera'">
        <weather-cams-widget />
    </div>
    <div ng-if="widget.Type == 'Fire'">
        <fire-widget />
    </div>
    <div ng-if="widget.Type === 'Link'">
        <div ng-if="widget && widget.Title && widget.Url">
            <link-widget
                widget-type=widget.Type
                background-image="isBreakpointSmall ? widget.ThumbnailMobile : widget.Thumbnail"
                header-text="widget.Title"
                link-url="widget.Url"
                icon="widget.LifestyleIcon"
            />
        </div>
    </div>

    </div>
    <div ng-if="widget.Type == 'WeatherDetails'">
        <weather-details-widget />
    </div>
    <div ng-if="widget.Type == 'Spark'">
        <spark-widget />
    </div>
    <div ng-if="widget.Type == 'LifestyleIndex'">
        <div ng-if="widget && widget.Title && widget.URLAlias">
        <link-widget
            widget-type=widget.Type
            background-image="isBreakpointSmall ? widget.BackgroundMobile : widget.Background"
            header-text="widget.Title"
            icon="widget.LifestyleIcon"
            link-url="'/life/' + widget.URLAlias + '/'"
        />
    </div>

    </div>
    <div ng-if="widget.Type == 'NewsSection'">
    <div
    wb-news-section-widget
    widget="widget"></div>
    </div>
    <div ng-if="widget.Type == 'AirQuality'">
        <air-quality-widget />
    </div>
    <div ng-if="widget.Type == 'FeaturedVideos'">
        <taboola-video-reel />
    </div>
    <div ng-if="widget.Type == 'Video'">
        <national-outlook-widget
            poster="isBreakpointSmall ? widget.PosterMobile : widget.Poster"
            link-url="widget.Url" />
    </div>
    `
    };
};
WB.WidgetGrids.WidgetDirective.$inject = [];

WB.App.directive('wbWidget', WB.WidgetGrids.WidgetDirective);
